import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: {
  showModal: boolean;
  showBanner: boolean;
  limit: number | null;
  totalTransactions: number | null;
} = {
  showModal: false,
  showBanner: false,
  limit: null,
  totalTransactions: null,
};

const slice = createSlice({
  name: "TrialLimitation",
  initialState,
  reducers: {
    setShowModal(state, action: PayloadAction<boolean>) {
      state.showModal = action.payload;
    },
    setShowBanner(state, action: PayloadAction<boolean>) {
      state.showBanner = action.payload;
    },
    setLimitContext(
      state,
      action: PayloadAction<{
        limit: number | null;
        totalTransactions: number | null;
      }>
    ) {
      state.limit = action.payload.limit;
      state.totalTransactions = action.payload.totalTransactions;
    },
  },
});

export const { setShowBanner, setShowModal, setLimitContext } = slice.actions;

export default slice.reducer;
